import type { AdacPolicyDetails } from './model';

export const mockAdacPolicyDetails: AdacPolicyDetails = {
  customerNumber: '36147754',
  confirmationNumber: '140010811',
  policyholder: {
    name: 'Max Muster',
    dateOfBirth: '10.12.1990',
    street: 'Musterstraße 1',
    postalCode: '12345',
    city: 'Berlin',
  },
};
